import { routeObject } from './store/storeTypes';
import About from './views/about';
import { ChangePassword } from './views/changePassword';
import EmailVerification from './views/components/EmailVerification';
// import SignUp from "./views/singup";
import _ from 'lodash';
import LoginPage from 'views/LoginPage';
import SignUpPage from 'views/SignupPage';
import { ContactUs } from 'views/contact-us';
import Sell from 'views/sell';
import SellForm from 'views/sell_form';
import Unsubscribe from 'views/unsubscribe';
import Appraisal from './appraisal/index';
import Survey from './views/components/Survey';
import DashBoard from './views/dashboard';
import Faq from './views/faq';
import ForgotPassword from './views/forgotPassword';
import Profile from './views/profile';
import RegistrarPage from './views/registrar-integrations/RegistrarPage';
import AgentDetailsQuestions from './views/registrar-integrations/agentDetailsQuestions';
import HireConsultant from './views/registrar-integrations/hireConsultant';
// import SingUpAndIntro from './views/registrar-integrations/pitchPage';
import RewampedLanding from './views/registrar-integrations/rewampedLanding';
import RegistrarLandingPage from './views/registrar-integrations/registrarLandingPage';
import Info from './views/registrar-integrations/startScreen';
import PaymentPage from 'views/registrar-integrations/RewampedLanding/PaymentPage';
import Calendly from 'views/registrar-integrations/RewampedLanding/Calendly';
import PaymentProgress from 'views/registrar-integrations/RewampedLanding/PaymentProgress';
import TestForm from 'views/registrar-integrations/RewampedLanding/TestForm';
import RedirectRoutePage from 'views/registrar-integrations/redirectRoute';
import RedirectEmptyRoutePage from 'views/registrar-integrations/redirectEmptyRoute';
import RedirectLoginPage from 'views/registrar-integrations/redirectLogin';
import AcquirePage from 'views/registrar-integrations/AcquirePage';
import AffiliatesPage from 'views/registrar-integrations/AffiliatesPage';
import AffiliateLoginPage from 'views/registrar-integrations/AffiliateLoginPage';
import AffiliateTermsPage from 'views/registrar-integrations/AffiliateTermsPage';

export const getRegistrarDetailFromLocalStorage = () => {
  let registrarObj = localStorage.getItem('registrarDetail');
  if (registrarObj) {
    let registrarDetail = JSON.parse(registrarObj);
    if (registrarDetail && !_.isEmpty(registrarDetail)) {
      return registrarDetail;
    }
  }
  return false;
};
// User Routes
let landingPageComponent = RewampedLanding;
// let landingPageComponent = SignUpAndIntro;
let registrarObj = getRegistrarDetailFromLocalStorage();
if (registrarObj) {
  // landingPageComponent = RegistrarLandingPage;
}
export const appraisalRoutes = [
  { path: '/appraisal', Component: Appraisal, isPrivateRoute: false },
  { path: '/about-us-appraisal', Component: About },
  { path: '/Faq-appraisal', Component: Faq },

  // {path: '/edit-profile', Component: AppraisalProfile, isPrivateRoute: true},
];

export const userRoutes = [
  { path: '/registrar-message', Component: Info, hideLayout: true, hideMain: true },
  { path: '/forgot-password', Component: ForgotPassword, hideMain: true, hideLayout: true },
  { path: '/verify-email', Component: EmailVerification },
  { path: '/sample-registrar-flow', Component: RegistrarPage, hideLayout: true },
  { path: '/survey', Component: Survey },
  { path: '/faq', Component: Faq },
  { path: '/about', Component: About },

  { path: '/profile', Component: Profile, isPrivateRoute: true },
  { path: '/dashboard', Component: DashBoard, isPrivateRoute: true },
  { path: '/change-password', Component: ChangePassword, isPrivateRoute: true },
  { path: '/hire-consultant', Component: RedirectEmptyRoutePage },
  // { path: '/complete-payment', Component: PaymentPage, hideLayout: true, isPrivateRoute: false },
  { path: '/payment-progress', Component: PaymentProgress, hideLayout: true, isPrivateRoute: false },
  { path: '/calendly', Component: Calendly, hideLayout: true, isPrivateRoute: false },
  // { path: "/consultant-details", Component: ConsultantDetails, isPrivateRoute: true },
  { path: '/agent-details-questions', Component: AgentDetailsQuestions, isPrivateRoute: true },
  { path: '/unsubscribe', Component: Unsubscribe, hideLayout: true },
  { path: '/contact-us', Component: ContactUs },
  { path: '/sell', Component: Sell },
  { path: '/sell-domain', Component: SellForm, hideLayout: true, hideMain: true },

  // Appraisal page

  // {path: '/testing-indu', Component: Payment, hideLayout: true, hideMain: true},
  { path: '/', Component: landingPageComponent },
  { path: '/acquire', Component: AcquirePage, hideLayout: true, hideMain: true },
  { path: '/affiliates', Component: AffiliatesPage, hideLayout: true, hideMain: true },
  { path: '/affiliates/login', Component: AffiliateLoginPage, hideLayout: true, hideMain: true },
  { path: '/affiliates/terms', Component: AffiliateTermsPage, hideLayout: true, hideMain: true },
  { path: '/registrar-landing-page', Component: RedirectRoutePage },
  { path: '/login', Component: RedirectLoginPage },
  // { path: '/login', Component: LoginPage, hideLayout: true, hideMain: true },
  { path: '/appraisal-login', Component: LoginPage, hideLayout: true, hideMain: true },
  { path: '/signup', Component: SignUpPage, hideLayout: true, hideMain: true },
  { path: '/test-route', Component: TestForm, hideLayout: true, hideMain: true },
  ...appraisalRoutes,
];

export const consultantRouter = [
  // { path: "/consultant-login", Component: Login, hideLayout: true, showCaptcha: true },
];

// Registrar Pages
export const registrarRoutes = [{ path: '/forgot-password-registrar', Component: ForgotPassword, hideLayout: true }];

export const routes: routeObject[] = [...userRoutes, ...consultantRouter, ...registrarRoutes, ...appraisalRoutes];
